import { RouteName } from '@mews-commander/enums';
import { lt } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { LinkButton } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';

export const ProductCheckListLinkButton = () => {
    const resolveRoute = useResolveRoute();
    return (
        <LinkButton
            href={resolveRoute(RouteName.ProductCheckListIndex)}
            wide
            variant="secondary"
            size="medium"
            icon={IconName.ViewReport}
        >
            {lt('GuestInHouseReportViewInProductCheckListButton')}
        </LinkButton>
    );
};
